import script from "./SearchList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchList.vue?vue&type=script&lang=ts&setup=true"

import "./SearchList.vue?vue&type=style&index=0&id=0acd9efa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0acd9efa"]])

export default __exports__